import React from "react";
import { Input, Label } from "reactstrap";

const RegisterAgreementCheckboxes = ({
  nilPolicy,
  setNilPolicy,
  typicalRestrictions,
  setTypicalRestrictions,
  stateLaw,
  setStateLaw,
  tac,
  setTac,
  tacModalToggle,
  tol,
  setTol,
  tolToggle,
  tax,
  setTax,
  taxToggle,
  agreement,
  setAgreement,
  agreeToggle,
  marketing,
  setMarketing,
  athleteAgreement,
  setAthleteAgreement,
  solely,
  setSolely,
  siteAdminAgreement,
  setSiteAdminAgreement,
  check1,
  setCheck1,
}) => {
  return (
    <>
      <div className="d-flex mt-4 ml-4">
        <Input
          required
          type="checkbox"
          id="nilPolicyCheck"
          className="custom-checkbox"
          checked={nilPolicy}
          onChange={(e) => setNilPolicy(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          <p className="text-dark">
            I understand and agree that I am responsible to check Name, Image
            and Likeness (NIL) policy at my school. I will check to see if I
            can use my school's institutional marks/logos and/or use
            institutional facilities at my school for my NIL activity.
          </p>
        </Label>
      </div>

      <div className="d-flex mt-4 ml-4">
        <Input
          required
          type="checkbox"
          id="typicalRestrictionsCheck"
          className="custom-checkbox"
          checked={typicalRestrictions}
          onChange={(e) => setTypicalRestrictions(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          <p className="text-dark">
            I UNDERSTAND MANY SCHOOLS APPLY AS TYPICAL RESTRICTIONS that: Use
            of any registered marks, logos, verbiage, or designs owned and
            protected by the school is not permitted unless athlete receives
            prior written permission.
          </p>
        </Label>
      </div>

      <div className="d-flex mt-4 ml-4">
        <Input
          required
          type="checkbox"
          id="stateLawCheck"
          className="custom-checkbox"
          checked={stateLaw}
          onChange={(e) => setStateLaw(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I understand and agree that I am also responsible to familiarize
          myself about rules for NIL
        </Label>
      </div>

      <div className="d-flex mt-4 ml-4">
        <Input
          required
          type="checkbox"
          id="tacCheck"
          className="custom-checkbox"
          checked={tac}
          onChange={(e) => setTac(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          Accept terms &amp; conditions for use of FHP platform and websites.{" "}
          <b
            className="pointer text-primary"
            onClick={tacModalToggle}
            style={{ cursor: "pointer" }}
          >
            View
          </b>
        </Label>
      </div>

      <div className="d-flex mt-5 ml-4">
        <Input
          required
          type="checkbox"
          id="tolCheck"
          className="custom-checkbox"
          checked={tol}
          onChange={(e) => setTol(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I agree to terms of license for use of my amateur athlete name and
          photo.{" "}
          <b className="pointer text-primary" onClick={tolToggle}>
            View
          </b>
        </Label>
      </div>

      <div className="d-flex mt-4 ml-4">
        <Input
          required
          type="checkbox"
          id="taxCheck"
          className="custom-checkbox"
          checked={tax}
          onChange={(e) => setTax(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I accept Tax responsibility.{" "}
          <b className="pointer text-primary" onClick={taxToggle}>
            View
          </b>
        </Label>
      </div>

      <div className="d-flex mt-2 ml-4">
        <Input
          required
          type="checkbox"
          id="agreementCheck"
          className="custom-checkbox"
          checked={agreement}
          onChange={(e) => setAgreement(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I agree to limited registration term.{" "}
          <b className="pointer text-primary" onClick={agreeToggle}>
            View
          </b>
        </Label>
      </div>

      <div className="d-flex mt-2 ml-4">
        <Input
          required
          type="checkbox"
          id="marketingCheck"
          className="custom-checkbox"
          checked={marketing}
          onChange={(e) => setMarketing(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I agree that FansHelpPlayers has the right to use my selfie videos
          for marketing purposes.
        </Label>
      </div>

      {/* Previously uncontrolled — now properly wired */}
      <div className="d-flex mt-2 ml-4">
        <Input
          required
          type="checkbox"
          id="siteAdminCheck"
          className="custom-checkbox"
          checked={siteAdminAgreement}
          onChange={(e) => setSiteAdminAgreement(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I understand and agree that site administration can restrict or cancel
          my registration at any time without notice to me. I understand and
          agree that site administration can act at its sole discretion
          regarding restricting and/or canceling my registration.
        </Label>
      </div>

      <div className="d-flex mt-2 ml-4">
        <Input
          required
          type="checkbox"
          id="athleteAgreementCheck"
          className="custom-checkbox"
          checked={athleteAgreement}
          onChange={(e) => setAthleteAgreement(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I understand that when I contribute a digital item to be sold on the
          FHP platform, that despite best efforts to discourage it, an
          unauthorized copying by a fan buyer might still occur. I agree to
          hold FHP harmless and without liability if a buyer should make such
          unauthorized copy and sell it to a third party without making a
          payment to me.
        </Label>
      </div>

      <div className="d-flex mt-2 ml-4">
        <Input
          required
          type="checkbox"
          id="solelyCheck"
          className="custom-checkbox"
          checked={solely}
          onChange={(e) => setSolely(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I understand and agree that I am solely responsible to comply with
          relevant reporting requirements regarding my NIL-related earnings,
          including my earnings associated to my NIL activities on this
          FansHelpPlayers.com website.
        </Label>
      </div>

      <div className="d-flex mt-2 ml-4">
        <Input
          required
          type="checkbox"
          id="check1Check"
          className="custom-checkbox"
          checked={check1}
          onChange={(e) => setCheck1(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I understand that FansHelpPlayers, LLC WILL NOT PAY ME BASED ON MY
          ATHLETIC PERFORMANCE.
        </Label>
      </div>
    </>
  );
};

export default RegisterAgreementCheckboxes;
